import { Component, inject } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

import { TranslatePipe } from '@ngx-translate/core';

import { MapStore } from '../../../layouts/map-layout/map.store';
import { RtudataStore } from '../rtudata.store';

@Component({
  imports: [MatCheckboxModule, MatRadioModule, TranslatePipe],
  selector: 'norupe-greenhouse-data-switcher',
  template: `
    <h4
      class="mx-auto max-w-2xl text-base font-semibold text-gray-900 lg:mx-0 lg:max-w-none"
    >
      {{ 'MONITORING.data_display' | translate }}
    </h4>
    <mat-radio-group
      class="flex flex-col gap-2"
      aria-labelledby="example-radio-group-label"
      (change)="update($event.value)"
    >
      @for (layer of layers; track layer.name) {
        @if (layer.name !== 'objects') {
          <mat-radio-button
            class="example-radio"
            [checked]="RtudataStore.activeLayer() === layer.name"
            [disabled]="isDisabled(layer.name)"
            [value]="layer.name"
            >{{ layer.label | translate }}</mat-radio-button
          >
        } @else {
          @for (sublayer of layer.subLayers; track sublayer.name) {
            <mat-radio-button
              class="example-radio"
              [checked]="RtudataStore.activeLayer() === sublayer.name"
              [value]="sublayer.name"
              >{{ sublayer.label | translate }}</mat-radio-button
            >
          }
        }
        @if (isDisabled(layer.name) === 'zoom level') {
          <!-- <span class="text-sm text-gray-500">
            {{ 'MONITORING.zoom_for_layers' | translate }}
          </span> -->
        } @else if (isDisabled(layer.name)) {
          <span class="text-sm text-gray-500">
            {{ 'MONITORING.layer_no_data' | translate }}
          </span>
        }
      }
    </mat-radio-group>
  `,
})
export class GreenhouseDataSwitcherComponent {
  readonly RtudataStore = inject(RtudataStore);
  readonly mapStore = inject(MapStore);

  layers = [
    {
      label: 'Object layers',
      name: 'objects',
      subLayers: [
        { label: 'MONITORING.objects', name: 'objects' },
        // { label: 'MONITORING.species_type', name: 'species' },
      ],
    },
    { label: 'Ndvi', name: 'ndvi' },
    { label: 'MONITORING.temperature', name: 'thermal' },
  ];

  update(
    layer:
      | 'ndvi'
      | 'thermal'
      | 'species'
      | 'empty'
      | 'weed'
      | 'multiple'
      | 'objects',
  ) {
    this.RtudataStore.setActiveLayer(layer);
  }

  isDisabled(name: string) {
    const scan = this.RtudataStore.selectedScan();
    const zoomLevel = this.mapStore.zoomLevel();

    switch (name) {
      case 'ndvi':
        return scan?.ndvi_fgb_file ? null : true;
      case 'thermal':
        return scan?.thermal_fgb_file ? null : true;
      default:
        // Disable object layers if zoomLevel is lower than 21
        if (zoomLevel < 21) {
          return 'zoom level';
        }
        return scan?.has_object_data ? null : true;
    }
  }
}
